const LoadingDots = () => {
    return (
        <div className="flex gap-2">
            <p
                className="w-2 h-2 rounded-full bg-gray-600 animate-bounce"
                style={{animationDelay: '0s'}}
            ></p>
            <p
                className="w-2 h-2 rounded-full bg-gray-600 animate-bounce"
                style={{animationDelay: '0.15s'}}
            ></p>
            <p
                className="w-2 h-2 rounded-full bg-gray-600 animate-bounce"
                style={{animationDelay: '0.3s'}}
            ></p>
        </div>
    )
}

export default LoadingDots;